export default __webpack_public_path__ + "static/media/priscilia.694632ad.jpg";